// extracted by mini-css-extract-plugin
export default {"main":"WhatWeDoTitle_main__dCdJy","link":"WhatWeDoTitle_link__8d1H+"};